import React from 'react';
import {Route, Routes} from 'react-router-dom';
import Main from '../Components/Main/Main';
import CreateInvoice from '../PersonalOffice/CreateInvoice/CreateInvoice';
import CreationOfDesign from '../PersonalOffice/CreationOfDesign/CreationOfDesign';
import NewCart from '../PersonalOffice/Cart/NewCart';
import MainLessons from '../PersonalOffice/Education/Lessons/MainLessons';
import EducationModulesPage from '../PersonalOffice/Education/EducationModulesPage';
import EducationModuleSubModulePage from '../PersonalOffice/Education/EducationModuleSubModulePage';
import EducationModuleLessonsPage from '../PersonalOffice/Education/EducationModuleLessonsPage';
import ReportPage from '../PersonalOffice/ReportPage/ReportPage';
import PaperworkPDFView from '../Components/PDFView/PaperworkPDFView';

const AppRoutes: React.FC = () => {
	return (
		<Routes>
			<Route path={'/*'} element={<Main />} />
			<Route path={'/create_invoice/:id'} element={<CreateInvoice />} />
			<Route path={'/create_invoice'} element={<CreateInvoice />} />
			<Route path={'/creation_of_design'} element={<CreationOfDesign />} />
			<Route path={'/creation_of_design/:id'} element={<CreationOfDesign />} />
			<Route path={'/cart'} element={<NewCart />} />
			<Route path={'/lesson/:lessonId'} element={<MainLessons />} />
			<Route
				path={'/main_education/:moduleType'}
				element={<EducationModulesPage />}
			></Route>
			<Route
				path={'/main_education/module/submodule'}
				element={<EducationModuleSubModulePage />}
			/>
			<Route
				path={'/main_education/module/submodule/lessons'}
				element={<EducationModuleLessonsPage />}
			/>
			<Route path={'/main_education/sub_section'} element={<MainLessons />} />
			<Route path={`/report-page/:type/:id`} element={<ReportPage />} />
			<Route path={`/paperwork-print/:id`} element={<PaperworkPDFView />} />
		</Routes>
	);
};

export default AppRoutes;
